/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntraOPPack from './intra-op-pack';
import IntraOPPackDetail from './intra-op-pack-detail';
import IntraOPPackUpdate from './intra-op-pack-update';
import IntraOPPackDeleteDialog from './intra-op-pack-delete-dialog';

const IntraOPPackRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntraOPPack />} />
    <Route path="new" element={<IntraOPPackUpdate />} />
    <Route path=":id">
      <Route index element={<IntraOPPackDetail />} />
      <Route path="edit" element={<IntraOPPackUpdate />} />
      <Route path="delete" element={<IntraOPPackDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntraOPPackRoutes;
